export const LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED = 'isMobileFiltersWereApplied';
export const LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED = 'isDesktopFiltersWereApplied';
export const UX_FEEDBACK_MOBILE_EVENT_NAME = 'AudMonFilterMobWeb';
export const UX_FEEDBACK_DESKTOP_EVENT_NAME = 'AudMonFilterDesktop';
export const DAYS_THRESHOLD = 7;
